export const GET_CATEGORY_REQUEST ="GET_CATEGORY_REQUEST";
export const GET_CATEGORY_SUCCESS ="GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAILURE ="GET_CATEGORY_FAILURE";

export const GET_TYPES_REQUEST ="GET_TYPES_REQUEST";
export const GET_TYPES_SUCCESS ="GET_TYPES_SUCCESS";
export const GET_TYPES_FAILURE ="GET_TYPES_FAILURE";

export const GET_INSTRUCTORS_REQUEST ="GET_INSTRUCTORS_REQUEST";
export const GET_INSTRUCTORS_SUCCESS ="GET_INSTRUCTORS_SUCCESS";
export const GET_INSTRUCTORS_FAILURE ="GET_INSTRUCTORS_FAILURE";


// export const GET_TYPE_REQUEST ="GET_CATEGORY_REQUEST";
// export const GET_TYPE_SUCCESS ="GET_CATEGORY_SUCCESS";
// export const GET_CATEGORY_FAILURE ="GET_CATEGORY_FAILURE";